import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';
import { formatMoney } from '../../utils/currency';

const PoDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [poData, setPoData] = useState(null);
  const [message, setMessage] = useState('');
  const {user,setUser} = useContext(UserContext);

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user])

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URI}/api/po/getMasterPO?id=${id}`, {withCredentials:true})
      .then((res) => {
        setPoData(res.data.data);
      })
      .catch(() => {
        setMessage('Failed to load PO details');
      });
  }, [id]);

  if (!poData) return <div className="p-6 text-center">Loading...</div>;

  return (
    <div className="bg-gray-50 min-h-screen">
      <style>
        {`
          @media print {
            body {
              background-color: #fff;
            }
            .bg-gray-50 {
              background-color: #fff !important;
            }
            .grid-cols-1.md\\:grid-cols-2 {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 1.5rem;
            }
            .print-hide {
              display: none !important;
            }
            button {
              display: none !important;
            }
            .shadow-md,
            .shadow-sm {
              box-shadow: none !important;
            }
            table, th, td {
              page-break-inside: avoid;
            }
          }

          /* Table styles */
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 1rem;
          }
          th, td {
            padding: 0.5rem;
            border: 1px solid #ddd;
            text-align: left;
          }
          th {
            background-color: #fffbe6;
            font-weight: bold;
          }
          tr:nth-child(even) {
            background-color: #f4f4f4;
          }
          .item-header {
            font-weight: bold;
            padding: 0.5rem;
            border-bottom: 1px solid #ddd;
          }
        `}
      </style>

      {/* Header */}
      <div className="bg-lime-800 p-4 flex items-center text-white shadow-md">
        <button onClick={() => navigate(-1)} className="text-xl font-bold">
          ←
        </button>
        <h2 className="text-xl md:text-2xl font-semibold ml-4">PO #{poData._id.slice(-4)}</h2>


        {/* Print Button */}
         <Link className='ml-auto' to="/central/po/print" state={{ poData }}>
           <button className="bg-green-500 hover:bg-green-700 text-white px-4 py-2 rounded">
               View PO
        </button>
         </Link>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-4 py-6 space-y-6">
      {poData.grn && (
        <div className='bg-green-100 border border-green-700 rounded px-5 py-3'>
          <p className=''>Goods Received Number: {poData.grn}</p>
        </div>
      )}

        {/* Zone & Supplier Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Zone Info Card */}
          <div className="bg-white rounded-lg shadow-sm border p-5">
            <h3 className="text-lg font-semibold text-yellow-700 mb-3">Zone Information</h3>
            <div className="space-y-2 text-sm">
              <p><span className="font-medium">Name:</span> {poData.zone.desc}</p>
              <p><span className="font-medium">Address:</span> {poData.zone.address}</p>
              <p><span className="font-medium">Zone ID:</span> {poData.zone.id}</p>
            </div>
          </div>

          {/* Supplier Info Card */}
          <div className="bg-white rounded-lg shadow-sm border p-5">
            <h3 className="text-lg font-semibold text-yellow-700 mb-3">Supplier Details</h3>
            <div className="space-y-2 text-sm">
              <p><span className="font-medium">Name:</span> {poData.supplier.name}</p>
              <p><span className="font-medium">Company:</span> {poData.supplier.company}</p>
              <p><span className="font-medium">Address:</span> {poData.supplier.address}</p>
              <p><span className="font-medium">Contact:</span> {poData.supplier.contact}</p>
              <p>
                <span className="font-medium">Account:</span>{" "}
                {poData?.supplier?.accountDetails?.accountNo
                  ? `${poData.supplier.accountDetails.accountNo} (${poData.supplier.accountDetails.name})`
                  : "Acc No Unavailable"}
              </p>
            </div>
          </div>
        </div>

        {/* Items List Section */}
<div className="mt-6">
  <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">Items</h2>
  {poData.items && poData.items.length > 0 ? (
    <table className="w-full border-collapse">
      <thead>
        <tr className="item-header">
          <th>Item Name</th>
          <th className="text-center">Quantity</th>
          <th className="text-center">Unit</th>
          <th className="text-center">Unit Price</th>
          <th className="text-center">Total</th>
        </tr>
      </thead>
      <tbody>
        {poData.items.map((itemWrapper, index) => {
          const item = itemWrapper.item;
          return (
            <React.Fragment key={index}>
              {/* Item Name Header */}
              <tr className="">
                <td>{item.name}</td>
                <td className="text-center"> {itemWrapper.quantity}</td>
                <td className="text-center">{item.unit}</td>
                <td className="text-center">{formatMoney(user, itemWrapper.price)}</td>
                <td className="text-end">{formatMoney(user, itemWrapper.price*itemWrapper.quantity)}</td>
                {console.log(itemWrapper)}
              </tr>

              {/* Item Details */}
              <tr>
                

              </tr>
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  ) : (
    <div className="bg-red-100 text-red-600 p-4 rounded text-center">
      No items found in this PO.
    </div>
  )}
</div>

        {/* Remarks */}
        {poData.remarks && (
          <div className="bg-white rounded-lg shadow-sm border p-5 mt-4">
            <h3 className="text-base font-semibold text-yellow-700 mb-2">Remarks</h3>
            <p className="text-sm text-gray-700">{poData.remarks}</p>
          </div>
        )}

        {/* Error Message */}
        {message && (
          <div className="bg-red-100 text-red-600 p-4 rounded text-center">
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default PoDetails;